// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IHouseOfferHistoryRequestV5Schema {
  /** Тип сделки **/
  dealType?: EDealType;
  /** Идентификатор дома realty **/
  houseId: number;
  /** Отдать объявления в соседних домах **/
  isNearby?: boolean;
  /** Статус объявлений **/
  offerStatus?: EOfferStatus;
  /** Номер страницы результатов **/
  page?: number;
  /** Кол-во результатов в ответе **/
  resultsOnPage?: number;
  /** Количество комнат **/
  roomsCount?: ERoomsCount;
  /** Площадь объекта **/
  totalArea: number;
}
export enum EDealType {
  /** Аренда **/
  'Rent' = 'rent',
  /** Продажа **/
  'Sale' = 'sale',
}
export enum EOfferStatus {
  /** Снято с публикации **/
  'Deactivated' = 'deactivated',
  /** Опубликовано **/
  'Published' = 'published',
}
export enum ERoomsCount {
  /** Пять комнат **/
  'Five' = 'five',
  /** Четыре комнаты **/
  'Four' = 'four',
  /** Одна комната **/
  'One' = 'one',
  /** Отдельная комната(покупка/аренда отдельной комнаты в квартире) **/
  'OnlyRoom' = 'onlyRoom',
  /** Шесть и более комнат **/
  'SixPlus' = 'sixPlus',
  /** Студия **/
  'Studio' = 'studio',
  /** Три комнаты **/
  'Three' = 'three',
  /** Две комнаты **/
  'Two' = 'two',
}
